module.exports = __webpack_public_path__ + "media/images/design-a739e25f5ad3ee4d63d5c0a86d771544.png";